export default __webpack_public_path__ + "static/media/logo.0c28ece6.svg";